export const isBrowser =
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  typeof navigator.userAgent !== 'undefined' &&
  !navigator.userAgent.includes('Node.js') &&
  !navigator.userAgent.includes('jsdom')
